/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ImportExamItemViewModel } from "../types/ImportExamItemViewModel.ts";

export const importExamItemViewModelSchema = z.object({
  examItemIds: z
    .array(z.number().int())
    .describe("Lista de IDs das questões a serem importadas para a prova.")
    .nullish(),
}) as unknown as ToZod<ImportExamItemViewModel>;
